export const MENU_CLOSE_DELAY_MS = 200;
